import React from 'react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import FeedbackModal from './FeedbackModal';

/**
 * Componente de diálogo de confirmación moderno
 * 
 * @param {boolean} isOpen - Si el diálogo está abierto
 * @param {function} onClose - Callback para cancelar
 * @param {function} onConfirm - Callback para confirmar
 * @param {string} title - Título del diálogo
 * @param {string} message - Mensaje de confirmación
 * @param {string} confirmText - Texto del botón confirmar (default: "Confirmar")
 * @param {string} cancelText - Texto del botón cancelar (default: "Cancelar")
 * @param {object} icon - Objeto de icono FontAwesome (default: faTrash)
 * @param {string} type - Tipo de confirmación: 'danger', 'warning', 'info' (default: 'danger')
 * @param {string} successMessage - Mensaje de éxito (opcional)
 * @param {string} errorMessage - Mensaje de error (opcional)
 * @param {function} onSuccessClose - Callback cuando se cierra el mensaje de éxito
 * @param {function} onErrorClose - Callback cuando se cierra el mensaje de error
 * @param {boolean} isProcessing - Estado de carga para deshabilitar acciones
 */
const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  icon = faTrash,
  type = 'danger',
  successMessage = '',
  errorMessage = '',
  onSuccessClose,
  onErrorClose,
  isProcessing = false
}) => {
  const hasResultMessage = Boolean(successMessage || errorMessage);
  const resultType = errorMessage ? 'error' : 'success';
  const resultMessage = errorMessage || successMessage;
  const resultOnClose = errorMessage ? onErrorClose : onSuccessClose;

  if (hasResultMessage) {
    return (
      <FeedbackModal
        isOpen={isOpen}
        type={resultType}
        title={title}
        message={resultMessage}
        confirmText={cancelText}
        showCancel={false}
        autoClose={0}
        onClose={resultOnClose || onClose}
        onConfirm={resultOnClose || onClose}
      />
    );
  }

  return (
    <FeedbackModal
      isOpen={isOpen}
      type={type === 'danger' ? 'confirm' : 'warning'}
      title={title}
      message={message}
      confirmText={confirmText}
      cancelText={cancelText}
      showCancel={true}
      isProcessing={isProcessing}
      onClose={onClose}
      onConfirm={onConfirm}
      icon={icon || faTrash}
    />
  );
};

export default ConfirmDialog;

